import { ButtonStylesStructure } from '@pijma/hero-types'

export const ButtonBaseStyles: ButtonStylesStructure['styleProvider'] = {
  root: ({ disabled, loading }) => ({
    display: 'flex',
    alignItems: 'center',
    cursor: disabled || loading ? 'default' : 'pointer',
    pointerEvents: disabled || loading ? 'none' : 'auto',
    background: 'transparent',
    border: 'none',
    margin: 0,
    padding: 0,
    width: 'auto',
    overflow: 'visible',
    fontWeight: 'normal',
    position: loading ? 'relative' : 'static',
  }),
  childrenWrapper: ({ loading }) => ({}),
  subtitle: () => ({}),
  startIcon: () => ({
    fontSize: 0,
    lineHeight: 1,
  }),
  endIcon: () => ({
    fontSize: 0,
    lineHeight: 1,
  }),
  loadingWrapper: () => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
  }),
}
